function assign(target, source) {
    // This works like Object.assign, but it doesn't overwrite existing properties.
    for (let property of Object.getOwnPropertyNames(source)) {
        if (!target.hasOwnProperty(property)) {
            target[property] = source[property]
        }
    }
}

export function tabsToRoutes(tabs) {
    let routes = []

    tabs.forEach(tab => {
        if (!tab.hasOwnProperty('parent')) {
            throw `Received tab with missing parent route: ${tab}`
        }

        if (!tab.hasOwnProperty('name')) {
            console.warn(`Received tab with missing name: ${tab}`)
        }

        let parent = tab.parent
        let options = tab.options || {}
        let children = tab.children || []

        assign(parent, options)

        children.forEach(child => {
            assign(child, options)
            child.path = `${parent.path}/${child.path}`
        })

        routes.push(parent)
        routes.push(...children)
    })

    return routes
}
